import {listCategories} from "seu-frontend/graphql/category/index.js";

const defaultState = () => ({
  categories: [],
  pagination: {
    page: 1,
    rowsPerPage: 10
  },
})

export default {
  namespaced: true,

  actions: {
    listCategories({commit}, input) {
      return listCategories(input, {includeTranslations: true})
        .then(categories => {
          commit('setCategories', categories.result)
          commit('setPagination', categories.pagination)
          return categories
        })
    }
  },

  mutations: {
    setCategories(state, categories) {
      state.categories = categories.map(category => ({
        ...category,
        details: category.details ? category.details : category.defaultTranslation
      }))
    },
    setPagination(state, pagination) {
      state.pagination = pagination
    }
  },

  state: defaultState()
}
